import { Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import CustomReactSelect from "../../../components/custom-react-select/CustomReactSelect";
import DeleteRegisterRecordConformation from "../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import CustomModal from "../../../components/modal/CustomModal";
import MulDartaaSelect from "../../../components/mul-dartaa-select/MulDartaaSelect";
import PendingPatientList from "../../../components/pending-patient-list/PendingPatientList";
import RegisterNotificationBell from "../../../components/notification/RegisterNotificationBell";
import { useNotificationAccept } from "../../../components/notification/useNotificationAccept";
import RegisterHeader from "../../../components/register-header/RegisterHeader";
import { AppMisc } from "../../../misc/appMisc";
import { ERROR, PANCHAKARMA, REQUIRED_FIELD, ROW_PER_PAGE, SEWA_THERAPY, SOMETHING_WENT_WRONG, SUCCESS, NOTIFICATION_ACCEPTED } from "../../../utils/constants";
import { INVALID_BLOOD_PRESSURE_MESSAGE, MUL_DARTA_NUMBERS_LIST } from "../../../utils/constants/forms";
import { DateUtils } from "../../../utils/dateUtils";
import { SessionStorage } from "../../../utils/storage/sessionStorage";
import PanchaKarmaRegister from "../../users/components/register/panchakarma-sewa-register/PanchaKarmaRegister";

const PanchaKarmaSewaForm = () => {
  const [modalTitle, setModalTitle] = useState("पञ्चकर्म सेवा रजिष्टर नयाँ रेकर्ड थप्नुहोस्");
  const [showPanchakarmaModal, setShowPanchakarmaModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [panchakarmaTableData, setPanchakarmaTableData] = useState([]);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const [showPanchakarmaDeleteModal, setShowPanchakarmaDeleteModal] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [panchakarmaDeleteId, setPanchakarmaDeleteId] = useState(null);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const [pendingPatientList, setpendingPatientList] = useState([])
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  const { handleAccept: handleNotificationAccept, addNotificationId } = useNotificationAccept({
    reset,
    setModalOpen: setShowPanchakarmaModal,
    setModalDefaultValues,
    transform: (data) => {
      if (data.palikaName) {
        data.palikaName = AppMisc.getMunicipalityName(data.palikaName);
      }
      return data;
    },
  });

  useEffect(() => {
    register("sewaTherapy", { required: true });
  }, [register]);

  const openPanchakarmaModal = () => {
    setShowPanchakarmaModal(true);
  };

  const closePanchakarmaModal = () => {
    setShowPanchakarmaModal(false);
    setModalDefaultValues();
    reset({
      bloodPressure: "",
      nature: "",
      weight: "",
      disease: "",
      bloodSugar: "",
      examination: "",
      fbs: "",
      sewaTherapy: "",
      referredIn: "",
      referredOut: "",
      patientFirstName: "",
      patientLastName: "",
      age: "",
      wardNumber: "",
      phoneNumber: "",
      nid: "",
      gaunOrTole: "",
    });
  };

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  const submitParchaKarmaRegister = (data) => {
    const isFromNotification = !!modalDefaultValues?.notificationId;
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    data = addNotificationId(data);
    AHMIS.post(API_URL.panchakarmaRegister, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closePanchakarmaModal();
          panchaKarmaPendingPatient()
          getPanchakarmaData(fromDate, toDate)
          if (isFromNotification) {
            AddAlertMessage({ type: SUCCESS, message: NOTIFICATION_ACCEPTED });
          }
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getPanchakarmaData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage])

  const getPanchakarmaData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.panchakarmaRegister}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(pageNumber))}&rowSize=${rowsPerPage}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setPanchakarmaTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const panchakarmaEdit = (id) => {
    AHMIS.get(API_URL.panchakarmaRegister + "/" + id)
      .then((response) => {
        const data = response?.data?.data;
        data.sewaTherapy = AppMisc.getLabelFromValues(SEWA_THERAPY, data.sewaTherapy);
        setModalDefaultValues(data);
        setShowPanchakarmaModal(true);
        if (data) {
          Object.keys(data).forEach((key) => {
            setValue(key, data[key]);
          });
        }
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };


  const closePanchakarmaDeleteModal = () => {
    setShowPanchakarmaDeleteModal(false);
    setPanchakarmaDeleteId(null);
  }

  const onDeletePanchakarmaRow = (id) => {
    setShowPanchakarmaDeleteModal(true);
    setPanchakarmaDeleteId(id);
  }

  const deletePanchaKarmaRow = (data) => {
    AHMIS.delete(API_URL.panchakarmaRegister + "/" + panchakarmaDeleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowPanchakarmaDeleteModal(false);
          setPanchakarmaDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getPanchakarmaData(fromDate, toDate)
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const handleSelectChange = (name, value) => {
    if (name === "sewaTherapy") {
      const selectedValue = SEWA_THERAPY
        .flatMap((type) => type.options)
        .find((option) => option.label === value)?.value || value;

      setValue(name, selectedValue);
    } else {
      setValue(name, value);
    }
  };

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    getPanchakarmaData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?sewaType=2&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      })
  }

  useEffect(() => {
    attachMulDartaaOptions();
  }, [])

  useEffect(() => {
    panchaKarmaPendingPatient()
  }, [])

  const panchaKarmaPendingPatient = () => {
    let url = `${API_URL.pendingPatient}?sewaType=${"2"}&fiscalYear=${DateUtils.getCurrentFiscalYear()}&registerConstant=${PANCHAKARMA}`;
    AHMIS.get(url).then((response) => {
      let jsondata = response.data;
      setpendingPatientList(jsondata.data)
    })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const refreshPanchakarmaData = () => {
    panchaKarmaPendingPatient();
    getPanchakarmaData(fromDate, toDate, searchParams);
  };

  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="पञ्चकर्म सेवा रजिष्टर"
          handleModalOpen={openPanchakarmaModal}
          getRegisterData={getPanchakarmaData}
          onHeaderParamChange={onHeaderParamChange}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
          rightElement={<RegisterNotificationBell targetRegister={PANCHAKARMA} onAccept={handleNotificationAccept} />}
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showPanchakarmaModal}
        onModalSubmit={handleSubmit(submitParchaKarmaRegister)}
        onModalClose={closePanchakarmaModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            handleSelectedDartaaMitiChange={handleDateChange}
            registerConstant={PANCHAKARMA}
          />
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6">General Examination</Typography>
        </Box>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="रक्तचाप (Blood Pressure)"
                size="small"
                variant="outlined"
                name="bloodPressure"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.bloodPressure}
                {...register("bloodPressure", {
                  pattern: /^(0|[1-9][0-9]*)\/(0|[1-9][0-9]*)$/,
                })}
              />
              {errors.bloodPressure && errors.bloodPressure.type === "pattern" && <span className="error-message">{INVALID_BLOOD_PRESSURE_MESSAGE}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="प्रकृति"
                size="small"
                variant="outlined"
                name="nature"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.nature}
                {...register("nature")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="तौल (KG)"
                size="small"
                variant="outlined"
                name="weight"
                type="number"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.weight}
                {...register("weight")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="रोग"
                size="small"
                variant="outlined"
                name="disease"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.disease}
                {...register("disease")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="व्लड सुगर"
                size="small"
                variant="outlined"
                name="bloodSugar"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.bloodSugar}
                {...register("bloodSugar")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="परीक्षण"
                size="small"
                variant="outlined"
                name="examination"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.examination}
                {...register("examination")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="FBS"
                size="small"
                variant="outlined"
                name="fbs"
                autoComplete="true"
                fullWidth
                defaultValue={modalDefaultValues?.fbs}
                {...register("fbs")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CustomReactSelect
                label="सेवा थेरापी"
                name="sewaTherapy"
                variant="outlined"
                options={SEWA_THERAPY}
                isMulti
                hasMultiLevelObject
                onChange={handleSelectChange}
                defaultValue={modalDefaultValues?.sewaTherapy}
                register={register}
                required
              />
              {errors?.sewaTherapy && errors.sewaTherapy?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label="प्रेषण भई आएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredIn"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredIn}
                fullWidth
                {...register("referredIn")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} >
              <TextField
                label=" प्रेषण भई गएको संस्थाको नाम"
                size="small"
                variant="outlined"
                name="referredOut"
                autoComplete="true"
                defaultValue={modalDefaultValues?.referredOut}
                fullWidth
                {...register("referredOut")}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomModal>
      {
        pendingPatientList.size > 0 &&
        <Box mt={2}>
          <PendingPatientList
            pendingPatientList={pendingPatientList}
            showModal={setShowPanchakarmaModal}
            modalDefaultValues={setModalDefaultValues}
            setValue={setValue}
          />
        </Box>
      }
      <DeleteRegisterRecordConformation
        showDeleteModal={showPanchakarmaDeleteModal}
        closeDeleteModel={closePanchakarmaDeleteModal}
        deleteRecord={deletePanchaKarmaRow}
      />
      <PanchaKarmaRegister
        onEditRow={panchakarmaEdit}
        tableData={panchakarmaTableData}
        deleteRow={onDeletePanchakarmaRow}
        totalSize={totalSize}
      />
    </>
  );
};

export default PanchaKarmaSewaForm;